<template>
  <div class="pumpMonitor">
    <header class="header">
      <div class="header_title">
        <img src="./img/left_arrow.png" />
        <h1>{{ isFirst ? '水泵控制柜手自动监测系统' : secondData.areaName }}</h1>
        <img src="./img/right_arrow.png" />
      </div>
      <div class="dateTime">
        <div class="date">
          <span>{{ currentDate }}</span>
          <span>Date</span>
        </div>
        <div class="time">{{ currentTime }}</div>
      </div>
      <div class="back">
        <img src="./img/back.png" @click="backHome" />
        <span>返回</span>
      </div>
    </header>
    <div class="left_con">
      <leftOne :areaId="areaId"></leftOne>
      <leftTwo :areaId="areaId"></leftTwo>
      <leftThree :areaId="areaId"></leftThree>
    </div>
    <rightCon :areaId="areaId" @checkMap="checkMap"></rightCon>
    <middleTop :areaId="areaId"></middleTop>
    <img src="./img/light.png" class="light" v-if="!isFirst" />
    <template>
      <pmap v-if="isFirst" @openNextData="openNextData"></pmap>
      <amap ref="customAmap" :areaData="secondData" v-else></amap>
    </template>
  </div>
</template>

<script>
  import { date } from 'utils'
  import leftOne from './leftOne'
  import leftTwo from './leftTwo'
  import leftThree from './leftThree'
  import rightCon from './rightCon'
  import middleTop from './middleTop'
  import pmap from './pmap'
  import amap from './amap'
  export default {
    components: {
      leftOne,
      leftTwo,
      leftThree,
      rightCon,
      middleTop,
      pmap,
      amap
    },
    data() {
      return {
        currentTime: '',
        currentDate: '',
        timer: null,
        isFullScreen: false,
        isFirst: true,
        secondData: {},
        areaId: ''
      }
    },
    created() {
      // 监听全屏变化
      this.setupFullscreenListeners()
    },
    mounted() {
      this.enterfullscreen()
      this.initDateTime()
    },
    methods: {
      checkMap(item) {
        if (!this.isFirst) {
          this.$refs.customAmap.locateDevice(Number(item.deviceMark))
        }
      },
      // 初始化日期时间
      initDateTime() {
        let dates = date(new Date())
        this.currentDate = [dates.YY, dates.MM, dates.DD].join('/')
        let times = date(new Date())
        this.currentTime = [times.hh, times.mm, times.ss].join(':')
        this.timer = setInterval(() => {
          let times = date(new Date())
          this.currentTime = [times.hh, times.mm, times.ss].join(':')
        }, 1000)
      },
      // 设置全屏监听器
      setupFullscreenListeners() {
        let isFullScreen =
          document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.fullScreen ||
          document.mozFullScreen ||
          document.webkitIsFullScreen
        isFullScreen = !!isFullScreen

        const fullscreenChangeHandler = () => {
          this.isFullScreen = !isFullScreen
        }

        document.addEventListener('fullscreenchange', fullscreenChangeHandler)
        document.addEventListener('mozfullscreenchange', fullscreenChangeHandler)
        document.addEventListener('webkitfullscreenchange', fullscreenChangeHandler)
        document.addEventListener('msfullscreenchange', fullscreenChangeHandler)
      },
      //进入全屏
      enterfullscreen() {
        let docElm = document.documentElement
        if (!this.isFullScreen) {
          if (docElm.requestFullscreen) {
            docElm.requestFullscreen()
          } else if (docElm.mozRequestFullScreen) {
            docElm.mozRequestFullScreen()
          } else if (docElm.webkitRequestFullScreen) {
            docElm.webkitRequestFullScreen()
          } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen()
          }
        }
      },
      // 退出全屏
      exitFullscreen() {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      },
      // 返回首页
      backHome() {
        if (this.isFirst) {
          this.exitFullscreen()
          this.$router.push({ name: 'home' })
        } else {
          this.isFirst = true
          this.secondData = {}
          this.areaId = ''
        }
      },
      openNextData(data) {
        this.areaId = data.area.id
        this.isFirst = false
        this.secondData = data
      }
    },
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  }
</script>

<style lang="less">
  html::-webkit-scrollbar {
    width: 0;
  }
</style>

<style lang="less" scoped>
  .pumpMonitor {
    height: 100%;
    background: url('./img/bg.png');
    background-size: 100% 100%;
    background-color: transparent;
    position: relative;

    .header {
      height: 6.77vh;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: 1;

      &_title {
        display: flex;
        justify-content: center;
        align-items: center;
        h1 {
          padding: 0 0.12rem;
          font-family: Alibaba-PuHuiTi-H;
          font-size: 3.34vh;
          font-weight: 600;
          letter-spacing: 1px;
          color: #aeffff;
          letter-spacing: 1;
          background: linear-gradient(180deg, #fff 50%, #15d6ff);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }

      .dateTime {
        position: absolute;
        right: 0.3rem;
        top: 5.47vh;
        display: flex;
        align-items: center;

        .date {
          display: flex;
          flex-direction: column;
          align-items: end;
          font-family: HiraginoSansGB-W3;
          font-size: 1.11vh;
          line-height: 1.3;
          color: #9ab7d6;
        }

        .time {
          margin-left: 0.09rem;
          font-family: Bahnschrift;
          font-size: 3.43vh;
          line-height: 0.86;
          color: #ffffff;
        }
      }

      .back {
        position: absolute;
        left: 0.31rem;
        top: 5.29vh;
        display: flex;
        align-items: center;

        img {
          width: 0.32rem;
          height: auto;
          cursor: pointer;
        }

        span {
          margin-left: 0.06rem;
          font-family: HiraginoSansGB-W3;
          font-size: 1.3vh;
          color: #9ab7d6;
        }
      }
    }

    .left_con {
      width: 4.89rem;
      position: absolute;
      left: 0;
      top: 9.46vh;
      bottom: 4.67vh;
      z-index: 1;
    }

    .right_con {
      width: 4.69rem;
      position: absolute;
      right: 0;
      top: 9.46vh;
      bottom: 4.67vh;
    }

    .light {
      position: absolute;
      left: 50%;
      top: 17.16vh;
      transform: translateX(-50%);
      width: 10.44rem;
      height: auto;
      z-index: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pumpMonitor/index.vue